<template>
</template>

<script>
import router from '@/router'
import 'jquery-toast-plugin/dist/jquery.toast.min'

export default {
  name: "Notifications",
  install(Vue, options) {

    let errorObjects = []

    function removeErrorMessages() {
      errorObjects.forEach(e => e.reset())
      errorObjects.splice(0, errorObjects.length)
    }

      router.beforeEach((to, from, next) => {
        removeErrorMessages()
        next()
      })

      Vue.prototype.$notifications = {

          error: function(text, heading) {
            errorObjects.push(
              $.toast({
                heading: heading || 'Viga',
                text: text,
                allowToastClose: true,
                position: 'bottom-left',
                icon: 'error',
                hideAfter: false,
              })
            )
          },

          warning: function(text, heading) {
            $.toast({
              heading: heading || 'Hoiatus',
              text: text,
              allowToastClose: true,
              position: 'bottom-left',
              icon: 'warning'
            })

          },

          info: function(text, heading) {
            removeErrorMessages()
            $.toast({
              heading: heading || 'Teade',
              text: text,
              allowToastClose: true,
              position: 'bottom-left',
              icon: 'success'
            })
          }
        }
    }
  }
</script>